import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 325.37 340.86"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "data-name": "Layer 2" }, [
  /*#__PURE__*/_createElementVNode("g", { "data-name": "Layer 1" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#00a13b",
      d: "m144.46 340.87-50.79-15.8 40.35-129.78L.97 197.72 0 144.54l206.68-3.77z"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#020202",
      d: "m92.439 16.636 50.52-16.64 26.356 80.022-50.52 16.64zM224.33 240.524l31.565-42.812 69.478 51.224-31.564 42.812zM224.232 97.029l69.037-49.226 30.88 43.308-69.037 49.226z"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }